import { render, staticRenderFns } from "./LoaderModal.vue?vue&type=template&id=347fd9f2"
import script from "./LoaderModal.vue?vue&type=script&lang=js"
export * from "./LoaderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports